import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { db } from "@/lib/firebase";
import { createSharedSubscription } from "@/lib/firestore/createSharedSubscription";
import type { BudgetItem } from "@amazing-wedding/shared-types";

export const budgetSubscription = createSharedSubscription<BudgetItem[]>({
  getDefault: () => [],
  attach: (weddingId, setSnapshot) => {
    setSnapshot({ data: [], loading: true });
    const q = query(
      collection(db, "weddings", weddingId, "budgetItems"),
      orderBy("createdAt", "asc"),
    );
    return onSnapshot(
      q,
      (snap) => {
        const items = snap.docs.map((d) => ({
          id: d.id,
          ...(d.data() as Omit<BudgetItem, "id">),
        }));
        setSnapshot({ data: items, loading: false });
      },
      () => setSnapshot({ data: [], loading: false }),
    );
  },
});
